import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@100mslive/hms-ai-ui";
import React from "react";

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  trigger: React.ReactNode;
  children: React.ReactNode;
};

export function MoreMenu({ open, setOpen, trigger, children }: Props) {
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-full p-0 py-1"
        sideOffset={8}
        align="end"
        style={{
          borderRadius: "8px",
          width: "calc(var(--radix-DropdownMenu-trigger-width) + 16px)",
          boxShadow: `
                    0px 2px 2px -1px var(--ColorsEffectsShadowsshadow-lg03),
                    0px 4px 6px -2px var(--ColorsEffectsShadowsshadow-lg02),
                    0px 12px 16px -4px var(--ColorsEffectsShadowsshadow-lg01)
                  `,
        }}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function MoreMenuItem({ children }: { children: React.ReactNode }) {
  return <DropdownMenuItem>{children}</DropdownMenuItem>;
}
